import { IconButton } from "@material-ui/core";
import React from "react";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import CreateDeploymentDialog from "./CreateDeploymentDialog";
import { UpdateDeploymentProps } from "./DeploymentDetails";
import {useAuthorization} from "../../authorizer/components/AuthorizationProvider";
import {update} from "final-form-arrays";


interface DeploymentEditorProps {

  basePath?: string;
  resourceAppId?: string;
  version?: string;
  updateDeployment?: UpdateDeploymentProps;

}

 const baseRegions = [
      { key: "Australia", value: "au" },
      { key: "South-east Asia (Singapore)", value: "ap" },
      { key: "UK South", value: "uk" },
      { key: "Global", value: "global" },
      { key: "EU-West", value: "eu-west" },
    ];


function getDeployedRegion(location: string): any[] {
  return baseRegions.filter((region) => region.value === location);
}

export const DeploymentEditor: React.FC<DeploymentEditorProps> = ({
  basePath = '',
  resourceAppId = '',
  version = '',
  updateDeployment
}) => {
  
  const [editDeployment, setEditDeployment] = React.useState<boolean>(false);
    const { isActionAllowed } = useAuthorization("SERVICE" , updateDeployment?.serviceId ? updateDeployment?.serviceId : '' );
    const canUpdate = isActionAllowed("update");
  return (
    <>
      <IconButton onClick={() => setEditDeployment(true)} disabled={updateDeployment?.deploymentStatus!=="DEPLOY_COMPLETED" || !canUpdate}>
        <EditOutlinedIcon />
      </IconButton>
      {editDeployment && (
        <CreateDeploymentDialog
          open={editDeployment}
          onClose={() => setEditDeployment(false)}
          onSuccess={() => {
            setEditDeployment(false);
            if(updateDeployment?.refreshDeployments === undefined){
              return;
            }
              else{
                updateDeployment?.refreshDeployments();
              }
            }
            } 
          basePath={basePath}
          resourceAppId={resourceAppId}
          version={version}
          availableRegions={getDeployedRegion(updateDeployment?.region || '')}
          updateDeployment={updateDeployment}
        />
      )}
    </>
  );
};

